<template>
  <v-card
    class="mx-auto my-3"
    max-width="400"
    color="#DDDDFF"
  >
    <div class="assigned-card">
      <p style="color:#444499"><b>ミッションメンバー</b></p>
      <div class="assigned-table">
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr v-for="assigned in assignedUsers" :key="assigned.name">
              <td>{{ assigned.name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    </div>
  </v-card>
</template>
<script>
export default {
  plops: [],
  data() {
    return {

    }
  },
  computed: {
    assignedUsers(){
      return this.$store.state.missionInfo.assignedUsers
    }
  }
}
</script>
<style>
</style>
